import { CONFIG_ENV } from '@m/config/env';

import type { AppName } from '@m/types/AppName';

type FaviconTheme = 'light' | 'dark';

const DARK_APPS: AppName[] = ['admin', 'specialist'];

function getEnvironmentSuffix(): string {
  if (CONFIG_ENV === 'production') return '';
  if (CONFIG_ENV === 'staging') return '-staging';
  return '-dev';
}

export function getFaviconTheme(appName: AppName): FaviconTheme {
  return DARK_APPS.includes(appName) ? 'dark' : 'light';
}

export function getFaviconUrl(appName: AppName): string {
  const theme = getFaviconTheme(appName);
  const envSuffix = getEnvironmentSuffix();
  return `/favicon-${theme}${envSuffix}.png`;
}

/**
 * Sets the favicon in the document head based on the app name and environment.
 * - Admin and Specialist apps use dark favicons
 * - All other apps use light favicons
 * - Environment suffix: -dev (development/local), -staging (staging), none (production)
 */
export function setFavicon(appName: AppName): void {
  const url = getFaviconUrl(appName);

  // Remove existing favicon links
  const existingLinks = document.querySelectorAll(
    'link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]',
  );
  existingLinks.forEach((link) => link.remove());

  // Add new favicon link
  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/png';
  link.href = url;
  document.head.appendChild(link);
}
